import { CardFragment } from 'apps/shared/scripts/graphql/fragments/CardFragment.generated';

import { FormValues } from '../components/CardForm/types';

const getDefaultValues = (card: CardFragment): FormValues => {
  return {
    designId: card.design.id,
    headline: card.headline,
    recipientName: card.recipientName,
    senderName: card.senderName ?? '',
  };
};

export default getDefaultValues;
